export default __webpack_public_path__ + "static/media/discord.c06de7bb.svg";